import { NotesOutlined } from "@mui/icons-material";
import {
  Box,
  Checkbox,
  FormControlLabel,
  InputAdornment,
  ListItemText,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { memo } from "react";
import HelpIconButton from "../../../../components/buttons/HelpIconButton";
import Baseline from "../../../../components/form/Baseline";
import SelectorBox from "../SelectorBox";

function CustomFieldWrapper({
  value,
  readOnly,
  size,
  variant = "filled",
  isEditable = true,
  margin = "dense",
  role = "personal",
  helperText = "",
  disabled,
  placeholder = "",
  field = {},
  fieldId = "",
  clearError = () => {},
  onChange = () => {},
  error = null,
}) {
  const isFlag =
    Boolean(field?.inputType?.category === "flag") ||
    typeof value === "boolean";

  if (!isEditable) {
    return (
      <Baseline
        Icon={(props) =>
          isFlag ? (
            <Checkbox checked={Boolean(value)} readOnly />
          ) : (
            <NotesOutlined {...props} />
          )
        }
        value={isFlag ? (value ? "Sim" : "Não") : value}
        emptyLabel={"Nada informado"}
        label={field?.label || ""}
      />
    );
  } else {
    return (
      <SelectorBox
        Icon={(props) =>
          !isFlag &&
          (field?.icon ? (
            <Box
              pt={2}
              width={"56px"}
              display={"flex"}
              alignItems="center"
              justifyContent={"center"}
              height={"100%"}
              sx={{
                color: "action.active",
              }}
            >
              <span
                style={{
                  fontSize: "1.4rem",
                  mr: ".8em",
                  ml: 1,
                  ...props.iconSx,
                }}
                className="material-icons"
              >
                {field?.icon || "notes"}
              </span>
            </Box>
          ) : (
            <Box width={"56px"} />
          ))
        }
        active={Boolean(value)}
      >
        {field?.inputType?.category === "flag" ? (
          <Stack mt={1} width={"100%"} direction={"row"} pl={1.3}>
            <FormControlLabel
              sx={{
                gap: 1.5,
                alignItems: field?.helperText ? "flex-start" : "center",
              }}
              control={
                <Checkbox
                  checked={Boolean(value)}
                  onClick={() => onChange(fieldId, !Boolean(value))}
                />
              }
              label={
                <ListItemText
                  primary={field?.label ?? ""}
                  secondary={field?.helperText ?? ""}
                  slotProps={{
                    primary: {
                      fontWeight: 600,
                    },
                  }}
                />
              }
            />
          </Stack>
        ) : (
          <Stack mt={1} width={"100%"}>
            <Typography mb={-0.6} variant="subtitle2" color="textSecondary">
              {field?.label}
            </Typography>
            <TextField
              disabled={disabled}
              placeholder={field?.helperText || placeholder}
              fullWidth
              readOnly={readOnly}
              variant={variant}
              hiddenLabel
              name={fieldId}
              size={"small"}
              margin={margin}
              required={fieldId?.required}
              value={value}
              onChange={(e) => {
                clearError(fieldId);
                onChange(fieldId, e.target.value);
              }}
              multiline
              error={error}
              helperText={helperText}
              slotProps={{
                input: {
                  endAdornment: Boolean(field?.helperText) && (
                    <>
                      <InputAdornment position="end">
                        <HelpIconButton size="small">
                          {field?.helperText}
                        </HelpIconButton>
                      </InputAdornment>
                    </>
                  ),
                },
              }}
            />
          </Stack>
        )}
      </SelectorBox>
    );
  }
}

export default memo(CustomFieldWrapper);
